import { db } from 'firebase/index'
import { getConverter } from 'lib/firestore'
import { UserType } from 'types/user'

const userConverter = getConverter<UserType>()

export const fetchUser = (uid: string): Promise<UserType | Error> => {
  return db
    .collection('users')
    .doc(uid)
    .withConverter(userConverter)
    .get()
    .then((snapshot) => {
      const data = snapshot.data()
      if (!data) {
        return new Error('ユーザーが見つかりませんでした')
      }
      data.user_id = snapshot.id
      return data
    })
}
